import { Image } from 'antd'
import { FormLabels } from 'src/components'
import styles from './CustomPictureLabels.module.scss'

interface PropsType {
  imageUrl: string,
  title: string,
  subtitle: string,
  link?: string
}

const CustomPictureLabels = (props: PropsType) => {
  const { imageUrl, title, subtitle, link = null } = props

  return (
    <div className={styles['project']}>
      <Image
        width={50}
        height={50}
        alt='project-image'
        className={styles['img-border']}
        src={imageUrl}
        preview={{ src: imageUrl }}
      />
      <div className={styles['labels']}>
        <FormLabels
          title={title}
          subtitle={subtitle}
          url={link}
        />
      </div>
    </div>
  )
}

export default CustomPictureLabels
